export default __webpack_public_path__ + "static/Embed-101e9708faebc2b253c9f027a53c7f78.svg";